import { render } from "./Prayers.vue?vue&type=template&id=42a3c7a6&scoped=true"
import script from "./Prayers.vue?vue&type=script&lang=js"
export * from "./Prayers.vue?vue&type=script&lang=js"

import "./Prayers.vue?vue&type=style&index=0&id=42a3c7a6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a3c7a6"]])

export default __exports__